module.exports = {"652922100":"温宿镇","652922101":"吐木秀克镇","652922102":"克孜勒镇","652922103":"阿热勒镇","652922104":"佳木镇","652922105":"托甫汗镇","652922106":"共青团镇","652922107":"柯柯牙镇","652922200":"托乎拉乡","652922202":"恰格拉克乡","652922204":"依希来木其乡","652922206":"古勒阿瓦提乡","652922207":"博孜墩柯尔克孜族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652922.json
// module id = 3235
// module chunks = 0